import React from 'react';
import DialogActions from '@mui/material/DialogActions';

import { StyledBottomNavigation } from 'catering/components/StyledBottomNavigation';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import { useLayout } from 'bento-ordering/context/LayoutContext';

export function RouteModalFooter({ ...rest }) {
  const isMobile = useIsMobile();
  const { bottomNavComponentRef } = useLayout();

  const Content = isMobile ? StyledBottomNavigation : React.Fragment;
  return (
    <DialogActions>
      <Content {...rest} ref={bottomNavComponentRef} />
    </DialogActions>
  );
}
